/**
 * Maps section mutation failures to actionable copy and decides when local section state
 * has to be refetched. The section API opts out of the generic APIUtils error toast
 * (`suppressErrorToast`) so these messages are the ones the user actually sees.
 */

import { CASE_PLAN_SECTION_ERROR_MESSAGES } from '../constants/reentry-planning.constants';

const CONFLICT_STATUS = 409;
const NOT_FOUND_STATUS = 404;

const resolveErrorStatus = (error) => Number(error?.status ?? 0);

/**
 * @param {unknown} error - Rejection from the section API (a fetch `Response` for HTTP errors).
 * @param {string} fallbackMessage - Operation-specific copy for unclassified failures.
 * @returns {string} Message to toast.
 */
export const resolveSectionErrorMessage = (error, fallbackMessage) =>
  resolveErrorStatus(error) === CONFLICT_STATUS
    ? CASE_PLAN_SECTION_ERROR_MESSAGES.DEPENDENT
    : fallbackMessage;

/**
 * A 404 means the plan or section the UI is holding no longer exists, so a rollback alone
 * would leave stale rows on screen and every retry would fail the same way.
 *
 * @param {unknown} error - Rejection from the section API.
 * @returns {boolean} True when the detail view should be reloaded from the server.
 */
export const isStaleSectionStateError = (error) => resolveErrorStatus(error) === NOT_FOUND_STATUS;
